// extracted by mini-css-extract-plugin
module.exports = {"pokemonList":"PokemonList_pokemonList__3I9hQ"};